import Countdown from './Countdown.svelte';
import Festival from './Festival.svelte';

const routes = [
    {
        name: '/',
        component: Countdown,
    },
    {
        name: '/festival',
        component: Festival,
    }
];

export { routes }